/** Customer / community logos shown in trust strips (paths under public/). */
export interface ClientLogo {
  src: string;
  name: string;
}

/** Default horizontal strip used on homepage hero and communities marquee. */
export const DEFAULT_CLIENT_LOGOS: ClientLogo[] = [
  { src: '/img/communities/leclaire.webp', name: 'Leclaire Education Trust' },
  { src: '/img/communities/boss-doctors.avif', name: 'Boss Doctors' },
  { src: '/img/communities/nwscrs.webp', name: 'Northwest Society of Colon and Rectal Surgeons' },
  { src: '/img/communities/wpeh.webp', name: 'Women Physician Entrepreneurs of Houston' },
  { src: '/img/communities/saavs.webp', name: 'South Asian American Vascular Society' },
  { src: '/img/communities/soc.webp', name: 'Surgical Outcomes Club' },
  { src: '/img/communities/sbcrs.webp', name: 'Society of Black Colon & Rectal Surgeons' },
  { src: '/img/communities/wa-acs.webp', name: 'Washington State Chapter ACS' },
];
